// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"678":"89d025d943df0046a5e1","883":"6126cab0b68ef69f6256"}[chunkId] + ".js";
};